import React, { Children } from "react";
import { DevLinkProvider } from "../devlink/devlinkContext";

function Main({ children }) {
    return <DevLinkProvider>{children}</DevLinkProvider>;
}

export default Main;
